import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { provideStates } from '@ngxs/store';
import { NotFoundComponent, UnauthorizedComponent } from '@tran-monorepo/frontend/components';
import { KpisState, LocationState, OrgUnitState, SubjectAreasState } from '@tran-monorepo/frontend/states';
import { ManagementApplicationDetailState } from './application-processing/state/application-detail.state';
import { ApplicationsState } from './application-processing/state/applications.state';
import { AwardCommitteeState } from './deadlines/state/award-committee.state';

export const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: 'home',
        data: { title: 'management.page-titles.home' },
        loadComponent: () => import('./home/home.component').then(c => c.HomeComponent),
        canActivate: [MsalGuard]
    },
    {
        path: 'applications',
        data: { title: 'management.page-titles.application-overview' },
        loadComponent: () =>
            import('./application-processing/applications.component').then(c => c.ApplicationsComponent),
        providers: [provideStates([ApplicationsState])],
        canActivate: [MsalGuard]
    },
    {
        path: 'applications/:applicationId',
        loadComponent: () =>
            import('./application-processing/components/application-details/application-details.component').then(
                c => c.ApplicationDetailsComponent
            ),
        providers: [
            provideStates([
                ApplicationsState,
                ManagementApplicationDetailState,
                LocationState,
                OrgUnitState,
                SubjectAreasState,
                KpisState
            ])
        ],
        canActivate: [MsalGuard],
        data: { readonly: true }
    },
    {
        path: 'deadlines',
        data: { title: 'management.page-titles.date-and-deadlines' },
        loadComponent: () => import('./deadlines/deadlines.component').then(c => c.DeadlinesComponent),
        providers: [provideStates([AwardCommitteeState])],
        canActivate: [MsalGuard]
    },
    {
        path: 'not-found',
        data: { title: 'management.page-titles.not-found' },
        component: NotFoundComponent
    },
    {
        path: 'unauthorized',
        data: { title: 'management.page-titles.unauthorized', management: true },
        component: UnauthorizedComponent
    },
    {
        path: '**',
        redirectTo: 'not-found',
        pathMatch: 'full'
    }
];
